import axios from "axios";
import { enums } from "../../constants/enum";

const ENDPOINT_KEY = "report";
const ENDPOINT_URI = "/report";

export default function useReportService() {
  return {
    queryKey: ENDPOINT_KEY,
    getRevenueReport: async (
      period = enums.REPORTING_PERIODS.DAILY,
      startDate,
      endDate,
    ) => {
      const params = new URLSearchParams({
        period,
      });
      if (startDate) {
        params.append("startDate", startDate);
      }
      if (endDate) {
        params.append("endDate", endDate);
      }
      const response = await axios.get(`${ENDPOINT_URI}/revenue-report`, {
        params,
      });
      return response.data.payload;
    },
    getOrderStatusReport: async (
      period = enums.REPORTING_PERIODS.DAILY,
      startDate,
      endDate,
    ) => {
      const params = new URLSearchParams({
        period,
      });
      if (startDate) {
        params.append("startDate", startDate);
      }
      if (endDate) {
        params.append("endDate", endDate);
      }
      const response = await axios.get(`${ENDPOINT_URI}/order-status-summary`, {
        params,
      });
      return response.data.payload;
    },
    recentCampaigns: async () => {
      const response = await axios.get(`${ENDPOINT_URI}/recent-campaigns`);
      return response.data.payload;
    },
    salesReport: async (
      period = enums.REPORTING_PERIODS.DAILY,
      startDate,
      endDate,
    ) => {
      const params = new URLSearchParams({
        period,
      });
      if (startDate) {
        params.append("startDate", startDate);
      }
      if (endDate) {
        params.append("endDate", endDate);
      }
      const response = await axios.get(`${ENDPOINT_URI}/sales-report`, {
        params,
      });
      return response.data.payload;
    },
    stockReport: async (
      period = enums.REPORTING_PERIODS.DAILY,
      startDate,
      endDate,
    ) => {
      const params = new URLSearchParams({
        period,
      });
      if (startDate) {
        params.append("startDate", startDate);
      }
      if (endDate) {
        params.append("endDate", endDate);
      }
      const response = await axios.get(`${ENDPOINT_URI}/stock-availability`, {
        params,
      });
      return response.data.payload;
    },
  };
}
